import store from '@/store';

export default async(to, from, next) => {
  const redirect = target => {
    next({ name: target });
  };

  // 須登入頁面
  const restrictedRoutes = [
    'SearchResult',
  ];

  if(restrictedRoutes.indexOf(to.name) === -1) {
    next();
    return;
  }

  if(to.name === from.name) {
    next();
    return;
  }

  try {
    const result = store.dispatch('member/getLoginStatus', { root: true });
    if(!result) {
      redirect('/');
    }
    next();
  } catch (err) {
    console.error(err);
    redirect('/');
  }
};
